import { useState } from 'react';
import { EarconName, useEarcon } from '../../../hooks/useEarcon';
import { addBundle } from '../../../locale/createUseTextLocalizer';
import { getTextLocalizer } from '../../../locale/useTextLocalizer';
import { consecutiveDotsRegex, countPattern, ipAddressRegex, isIntegerRegex, liveRegex, urlRegex } from '../../../util';
import { validateTextInput } from '../useInputValidationAdapter';
import { stripProtocolFromUrl } from '../utils';
import bundle from '../NovaComponents-Input-gui-icu.properties';
addBundle(bundle);
let localize;
getTextLocalizer('NovaComponents-Input-gui-icu').then(localizer => {
  localize = localizer;
});
/**
 * URL Validation
 */

export const validateURLInput = props => {
  let isError = false,
    status = undefined,
    message = undefined;
  const colonIndex = props.value.lastIndexOf(':');
  const endOfPortNumberIndex = props.value.slice(colonIndex).indexOf('/') !== -1 ? props.value.slice(colonIndex).indexOf('/') + colonIndex : props.value.length;
  const urlWithoutProtocol = stripProtocolFromUrl(props.value);
  const result = validateTextInput({
    value: props.value,
    isRequired: props.isRequired,
    minLength: props.minLength
  });
  if (result.isError) {
    isError = result.isError;
    status = result.status;
    message = result.message;
  } else {
    if (props.value) {
      if (!props.isLive) {
        if (stripProtocolFromUrl(props.value).length === props.value.length && !urlRegex(props.value) && !ipAddressRegex(props.value)) {
          isError = true;
          status = 'alert';
          message = props.message || localize('urlValidator.msg');
        }
        if (stripProtocolFromUrl(props.value).length < props.value.length && !urlRegex(stripProtocolFromUrl(props.value)) && !ipAddressRegex(props.value)) {
          isError = true;
          status = 'alert';
          message = props.message || localize('urlValidator.msg');
        }
        const colonIndexFromStrippedUrl = urlWithoutProtocol.indexOf(':');
        let portNumber = props.value.slice(colonIndex + 1, endOfPortNumberIndex);
        portNumber = colonIndexFromStrippedUrl >= 0 && isIntegerRegex(portNumber) ? portNumber : '';
        if (portNumber !== '' && (parseInt(portNumber) > 99999 || urlWithoutProtocol.lastIndexOf('/') >= 0 && urlWithoutProtocol.lastIndexOf('/') < colonIndexFromStrippedUrl) || colonIndexFromStrippedUrl >= 0 && portNumber === '' || countPattern(urlWithoutProtocol, ':') > 1) {
          isError = true;
          status = 'alert';
          message = props.message || localize('urlValidator.msg');
        }
      } else {
        if (!liveRegex(props.value) && !ipAddressRegex(props.value)) {
          isError = true;
          status = 'alert';
          message = props.message || localize('urlValidator.msg');
        }
      }
      if (!consecutiveDotsRegex(props.value)) {
        isError = true;
        status = 'alert';
        message = localize('emailValidatorConsecutivePeriods.msg');
      }
    }
  }
  return {
    isError,
    status,
    message
  };
};
/**
 * This hook provide functionality to handle events such as onChange,onBlur
 * & onCancel.
 * For those who doesn't wish to use this,
 * @function validateURLInput is available for consumption
 * @param props
 *
 */
export const useURLValidationAdapter = props => {
  const earcon = useEarcon({
    source: EarconName.Error
  });
  const [value, setValue] = useState(props.initialValue ?? '');
  const [errors, setErrors] = useState({
    status: undefined,
    message: ''
  });
  const handleChange = event => {
    const liveValue = event.value;
    const result = validateURLInput({
      value: liveValue,
      isLive: true,
      isRequired: props.isRequired,
      message: props.message,
      urlRegex: props.urlRegex,
      liveURLRegex: props.liveURLRegex,
      minLength: props.minLength
    });
    setValue(liveValue);
    result.isError ? setErrors({
      status: result.status,
      message: result.message
    }) : setErrors({
      status: undefined,
      message: undefined
    });
    if (result.status === 'alert') earcon.play();
  };
  const handleBlur = () => {
    const result = validateURLInput({
      value,
      isLive: false,
      isRequired: props.isRequired,
      message: props.message,
      urlRegex: props.urlRegex,
      liveURLRegex: props.liveURLRegex,
      minLength: props.minLength
    });
    result.isError && setErrors({
      status: result.status,
      message: result.message
    });
  };
  const handleCommit = e => {
    const result = validateURLInput({
      value,
      isLive: false,
      isRequired: props.isRequired,
      message: props.message,
      urlRegex: props.urlRegex,
      liveURLRegex: props.liveURLRegex,
      minLength: props.minLength
    });
    result.isError && setErrors({
      status: result.status,
      message: result.message
    });
    if (result.status === 'alert' && e?.reason === 'enter') earcon.play();
  };
  const handleCancel = () => {
    setValue('');
    setErrors({
      status: undefined,
      message: undefined
    });
  };
  return {
    handleChange,
    value,
    errors,
    handleBlur,
    handleCancel,
    handleCommit
  };
};
//# sourceMappingURL=useURLValidationAdapter.js.map